/**
 * The Certificates capstone mark in its Capstone Key colourway.
 *
 * Inlined rather than taken from `@mc/certificates-design-system`'s
 * `CertShieldLogo`, whose fills resolve from `--c-*` tokens that only exist
 * inside `.certificates-theme` — a scope this page does not apply.
 * Geometry matches pages/certificates/assets/cert-shield-black.svg.
 */
export const CapstoneShield = ({
  className,
  width = 37,
  height = 40,
}: {
  className?: string
  width?: number
  height?: number
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 37 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
    aria-hidden='true'
    focusable='false'
  >
    <path
      d='M36.927 8.9735C37.0094 8.33681 36.6554 7.72376 36.0628 7.47675L19.0172 0.371317C18.6666 0.225186 18.2722 0.225186 17.9216 0.371317L0.875988 7.47674C0.283411 7.72375 -0.0705352 8.3368 0.0118344 8.9735L2.38118 27.2882C2.42991 27.6648 2.62712 28.0064 2.92896 28.2369L17.6053 39.4462C18.1155 39.8359 18.8234 39.8359 19.3336 39.4462L34.0099 28.237C34.3117 28.0064 34.5089 27.6648 34.5576 27.2882L36.927 8.9735Z'
      fill='#D8F90A'
    />
    <path
      d='M18.5284 18.5343L16.6547 12.0273H11.4766V13.0786H11.973C12.5862 13.0786 13.0923 13.4339 13.2821 14.1104L16.134 24.0339H18.7377L20.0128 19.6294L19.9933 19.6099C19.1611 19.6099 18.7572 19.3033 18.5284 18.5489V18.5392V18.5343Z'
      fill='#1E1E1E'
    />
    <path
      d='M29.0161 22.9689C28.4029 22.9689 27.9162 22.565 27.7313 21.9177L24.8794 12.0137H20.8984L24.3441 24.0056H29.5125V22.9543H29.0161V22.9641V22.9689Z'
      fill='#1E1E1E'
    />
    <path
      d='M7.84375 22.9707V24.0219H12.4379V22.9707H7.84375Z'
      fill='#1E1E1E'
    />
  </svg>
)
